/** Runtime switches for the API layer. */

export const API_BASE = "/api/v1";

/** Mock mode: VITE_MOCK=1 (default in `npm run dev` via .env.development). */
export const MOCK_ENABLED: boolean = import.meta.env.VITE_MOCK === "1";

/** Simulated network latency for mock mode, in ms. */
export const MOCK_LATENCY_MS = 180;
